import React from "react";
import { ForReviewTable } from "./view/ForReviewTable";

interface Props {}

export const ForReview: React.FC<Props> = () => {
  return (
    <>
      <ForReviewTable />
    </>
  );
};
